import {Container, Singleton} from 'typescript-ioc'
import BaseApi from '@/api/BaseApi'
import CompanyBook, {CompanyBookDetail} from '@/model/CompanyBook'
import Paging, {PagingQueryForm} from "biz-ts/src/api/Paging";
import {BaseQueryForm} from "biz-ts/src/api/Query";

@Singleton
export default abstract class CompanyBookApi {

    abstract paging(form: PagingQueryForm): Promise<Paging<CompanyBook>>

    abstract detail(id: string): Promise<CompanyBookDetail>

    abstract delete(id: string): Promise<void>

    abstract exportRentalLog(form: ExportRentalLogForm): Promise<Blob>
}

class CompanyBookApiImpl extends BaseApi implements CompanyBookApi {

    protected urlPrefix = 'company/book'

    paging(form: PagingQueryForm): Promise<Paging<CompanyBook>> {
        return this.axios.get('paging', {params: form})
    }

    detail(id: string): Promise<CompanyBookDetail> {
        return this.axios.get('detail', {params: {id: id}})
    }

    delete(id: string): Promise<void> {
        return this.axios.post('delete', {id: id})
    }

    exportRentalLog(form: ExportRentalLogForm): Promise<Blob> {
        return this.axios.post('exportRentalLog', form.toRequestParams(), {responseType: 'blob'})
    }
}

Container.bind(CompanyBookApi).to(CompanyBookApiImpl)

export class ExportRentalLogForm extends BaseQueryForm {

}
